module.exports = __webpack_public_path__ + "img/cs-exper-4.e7304cdf.jpg";